Core.DrawingTool = function (elem, showTools = true) {
    var $el = elem instanceof jQuery ? elem : $(elem);
    var $canvas = $el.find('.drawingTool-canvas');
    var $container = $el.find('.drawingTool-container');
    var $btnClear = $el.find('.drawingTool-btnClear');
    var $btnSave = $el.find('.drawingTool-btnSave');
    var $btnChooseTemplate = $el.find('.drawingTool-btnChooseTemplate');
    var $btnModifyPhoto = $el.find('.drawingTool-btnModifyPhoto');
    var $btnChoosePhoto = $el.find('.drawingTool-btnChoosePhoto');
    var $filePicker = $el.find('.drawingTool-filePicker');
    var $fileNameInput = $el.find('.drawingTool-fileNameInput');
    var $error = $el.find('.drawingTool-error');    

    var fileName = $el.data('file-name');

    function handleBtnClear() {
        $btnClear.on('click', function () {
            m.clear();
        });
    }

    function handleBtnSave(fileUploadObj, $fileUploadEl) {
        var scrollToUploadEl = function () {
            document.getElementById('checkoutHomeModification-fileupload').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
        };

        $btnSave.on('click', function () {
            // validate file name and file
            var fileName = getFileName();
            if (!fileName) {
                $fileNameInput.addClass('error');
                $fileNameInput.focus();
                return;
            }            

            if ($btnSave.closest('#homeMod-draw').length > 0 ) {
                $fileNameInput.removeClass('error');
            }

            // check if modifying existing photo
            var isModifying = false;
            if ($fileNameInput.data('is-modifying')) {
                isModifying = true;
            }

            // remove error
            $container.removeClass('error');
            $error.addClass('hidden');
            $fileNameInput.removeClass('error');

            $btnSave.prop('disabled', true);
            var $list = $fileUploadEl.find('.fileUpload-fileList');
            var fileCount = $list.find('.fileUpload-file').length || 0;

            // find modified items, hide existing
            var items = $list.find('.fileUpload-filename');            
            if (isModifying && items.length  > 0) {
                $(items).each(function(i, item) {
                    var name = $(item).text();
                    if ((isModifying && name === fileName)) {
                        $(item).closest('.fileUpload-file').hide();
                    }
                });  
            }

            var imagedata = $canvas.drawr("export", "image/png");
            var imageBlob = Core.Util.uploadBase64Image(imagedata);
            var imageFile = new File([imageBlob], fileName);

            fileUploadObj.uploadFile(imageFile, fileCount, function(resp) {
                // success callback
                $btnSave.prop('disabled', false);

                scrollToUploadEl();
                m.clear();
                //append to homeModsVar
                var existingImages = window.homeModsVar.existingImages;

                if (isModifying) {
                    // update existing image
                    existingImages.find(function(item) {
                        if (item.name === fileName) {
                            item.url = imagedata;
                        }
                    });
                } else {
                    existingImages.push({
                        name: fileName,
                        url: imagedata
                    });
                }

                window.homeModsVar.existingImages = existingImages;
                var $template = $('#drawingTool-existingPhoto');
                renderPopupItem($template, existingImages);
                
                if (isModifying) {
                    // check if isModifying
                    items = $list.find('.fileUpload-filename'); 
                    if (items.length  > 0) {
                        var duplicatedItems  = $(items).filter(function(i, item) {
                            var name = $(item).text();
                            if (isModifying) return name === fileName;
                        });
                        
                        // remove previous item
                        if (duplicatedItems.length > 1) {
                            var $btn = $(duplicatedItems[0]).closest('.fileUpload-file').find('.fileUpload-delete');
                            if ($btn) {
                                $btn.attr('data-is-modifying', isModifying);
                                $btn.trigger('click');
                            }
                        }
                    }

                }
            }, function() {
                // fail callback
                scrollToUploadEl();
                $btnSave.prop('disabled', false);
            }, isModifying);
        });
    }

    function handleOpenPhoto() {
        if ($filePicker[0]) {
            $filePicker[0].onchange = function () {
                var file = $filePicker[0].files[0];
                if (!file.type.startsWith('image/')) { return }
                var reader = new FileReader();
                reader.onload = function (e) {
                    $canvas.drawr("load", e.target.result);
                    $filePicker.val('');
                };
                reader.readAsDataURL(file);
            };
        }

        $btnChoosePhoto.on('click', function() {
            $filePicker.click();
        });
    }

    function getFileName() {
        var _fileName = fileName;
        if (_fileName) {
            if (_fileName.includes('{date}')) {
                var now = kendo.toString(new Date(), "yyyyMMdd_HHmmss");
                _fileName = _fileName.replaceAll('{date}', now);
            }

            return `${_fileName}.png`;
        } else if ($fileNameInput.val()) {
            return `${$fileNameInput.val()}.png`;
        } else {
            return '';
        }
    }

    function renderPopupItem($template, data) {
        var $grid = $template.find('.drawingTool-templateGrid');
        var id = $template.attr('id');
        var isExistingPhoto = id === 'drawingTool-existingPhoto';

        var templateItem = function(item) {
            return `
                <div class="drawingTool-templateItem" data-item-id="${item.id}">
                    <img class="drawingTool-templateImage" src="${item.url}" alt="Template ${item.name} - ${item.id}">
                    <span class="drawingTool-templateItemName">${item.name}</span>
                </div>
            `;
        };

        $grid.html('');
        if (data.length > 0) {
            data.map(function(item, i) {
                $grid.append(templateItem(item));
            });
        } else {
            $grid.html('<p class="pl-1">No items found.</p>');
        }

         // add click event
         $template.find('.drawingTool-templateItem').on('click', function() {
            var image = $(this).find('img').prop('src');
            var _$canvas = $('#homeMod-draw').find('.drawingTool-canvas');
            var _$fileNameInput = $('#homeMod-draw').find('.drawingTool-fileNameInput');
            _$canvas.drawr("load", image);
            
            // set filename input, make it readonly, add flag if it's modifying existing photo
            if (isExistingPhoto) {
                // get item name, remove substring .png
                var name = $(this).find('.drawingTool-templateItemName').text();                
                _$fileNameInput.val(name.replaceAll('.png', ''));
                _$fileNameInput.prop('readonly', true);
                _$fileNameInput.data('is-modifying', true);
            }

            $template.data('kendoWindow').close();

            // var popup = ClientPopup($template);
            // popup && popup.close();

            document.getElementById('homeMod-draw').scrollIntoView({
                behavior: 'smooth',
                block: 'center',
                inline: 'center'
            });
        });
    }

    function renderPopupGrid($template, data, $btnTrigger, popupTitle) {
        if ($template.hasClass('initialized')) return;

        renderPopupItem($template, data);
        $template.addClass('initialized');

        var popup;
        $btnTrigger.on('click', function() {
            popup = new ClientPopup($template, {title: popupTitle});
            popup.init();
        });
    }

    function handleGridTemplate() {
        var $template = $('#drawingTool-template');
        var data = window.homeModsVar;
        renderPopupGrid($template, data.templates, $btnChooseTemplate, "Choose template");
    }

    function handleModifyExistingPhoto() {
        var $template = $('#drawingTool-existingPhoto');
        var data = window.homeModsVar;
        renderPopupGrid($template, data.existingImages, $btnModifyPhoto, "Choose existing photo");
    }

    function initCanvas() {
        $canvas.drawr({
            enable_transparency: true,
            enable_transparency_image: true,
            enable_scrollwheel_zooming: false,
            undo_max_levels: 99,
            no_toolbox: !showTools, 
            // canvas_width: $container.width(),
            // canvas_height: $container.width() * (4/3),
        });

        $canvas.drawr("start");
    }

    var m = {
        init: function (fileUploadObj, $fileUploadEl) {
            initCanvas();
            handleBtnSave(fileUploadObj, $fileUploadEl);
            handleBtnClear();
            // handleBtnDelete();
            
            if (showTools) {
                handleOpenPhoto();
                handleGridTemplate();
                handleModifyExistingPhoto();
            }

            // set callback for delete
            // update existing images with current file list
            fileUploadObj.onDeleteSuccess = function(fileNameList, isModifying) {
                var existingImages = window.homeModsVar.existingImages;
                if (!isModifying) {
                    existingImages = existingImages.filter(function(item) {
                        return fileNameList.indexOf(item.name) !== -1;
                    });
                    window.homeModsVar.existingImages = existingImages;
                }

                var $template = $('#drawingTool-existingPhoto');
                renderPopupItem($template, existingImages);
            }

            if (!showTools) {
                $el.find('.drawr-toolbox').addClass('invisible');
            }

            m.resize();
            // $(window).trigger('resize');
        },
        clear: function () {
            $canvas.drawr("clear");
            $fileNameInput.val('');
            $fileNameInput.prop('readonly', false);
            $fileNameInput.data('is-modifying', false);
            $filePicker.val('');
        },
        resize: function () {
            // reposition canvas
            $(window).on('resize', function () {
                var containerPosition = $container.offset();
                // $canvas.css({
                //     left: containerPosition.left,
                //     top: containerPosition.top,
                //     width: $container.width(),
                //     height: $container.height(),
                // });

                $container.find('.sfx-canvas').css({
                    left: containerPosition.left,
                    top: containerPosition.top,
                    width: $container.width() - 1,
                    height: $container.height(),
                });

                $el.find('.drawr-toolbox-brush').css({
                    left: containerPosition.left,
                    top: containerPosition.top,
                })
            });
        }
    }

    return m;
};
